import { render, staticRenderFns } from "./reserveStatistics.vue?vue&type=template&id=4e8542e6&"
import script from "./reserveStatistics.vue?vue&type=script&lang=js&"
export * from "./reserveStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports